import Cookies from 'js-cookie';
import React from 'react';

interface GdprContext {
  isAcceptedCookies: boolean;
  setIsAcceptedCookies: (val: boolean) => void;
}

const GDPR_COOKIE_CONSENT_OK_EVENT = 'gdpr-cookie-consent-ok';
export const GdprContext = React.createContext<GdprContext>({} as any as GdprContext);

const useGdprContextProvider = (): GdprContext => {
  const [isAcceptedCookies, setIsAcceptedCookies] = React.useState(() =>
    Cookies.get('gdpr-cookie-consent') === 'true' ? true : false
  );

  React.useEffect(() => {
    const onCookieConsentOk = (): void => {
      setIsAcceptedCookies(true);
    };

    window.addEventListener(GDPR_COOKIE_CONSENT_OK_EVENT, onCookieConsentOk);

    return (): void => {
      window.removeEventListener(GDPR_COOKIE_CONSENT_OK_EVENT, onCookieConsentOk);
    };
  }, []);

  const GdprContextProvider: GdprContext = {
    isAcceptedCookies,
    setIsAcceptedCookies,
  };
  return GdprContextProvider;
};

const GdprContextProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  const GdprContextProvider = useGdprContextProvider();

  return <GdprContext.Provider value={GdprContextProvider}>{children}</GdprContext.Provider>;
};

export default GdprContextProvider;
